import { Box, BoxProps, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface EntityDirectoryEmptyStateProps extends BoxProps {
  children: ReactNode;
}

export function EntityDirectoryEmptyState({
  children,
  ...props
}: EntityDirectoryEmptyStateProps) {
  return (
    <Box
      bg="entityDirectory.surface"
      border="1px solid"
      borderColor="entityDirectory.border"
      p={8}
      textAlign="center"
      {...props}
    >
      <Text color="entityDirectory.mutedText">{children}</Text>
    </Box>
  );
}
